import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useState,
} from "react";
import DeviceHelper from "../helpers/DeviceHelper";

interface NavigationContextValue {
  isNavigationOpen: boolean;
  toggleNavigation: () => void;
  setNavigationOpen: (open: boolean) => void;
}

const NavigationContext = createContext<NavigationContextValue | undefined>(
  undefined,
);

export const NavigationProvider = ({
  children,
}: PropsWithChildren<unknown>) => {
  const [isNavigationOpen, setIsNavigationOpen] = useState(() =>
    DeviceHelper.isPC(),
  );

  const toggleNavigation = useCallback(() => {
    setIsNavigationOpen((prev: boolean) => !prev);
  }, []);

  const setNavigationOpen = useCallback((open: boolean) => {
    setIsNavigationOpen(open);
  }, []);

  return (
    <NavigationContext.Provider
      value={{ isNavigationOpen, toggleNavigation, setNavigationOpen }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigationToggle = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error(
      "useNavigationToggle must be used within NavigationProvider",
    );
  }
  return context;
};
